// extracted by mini-css-extract-plugin
module.exports = {"body":"styles_body_HijTe5NrtNgu5ORSwcu1"};